export interface Testimonial {
  id: string;
  authorInitials: string;
  authorName: string;
  date: string;
  rating: number;
  excerpt: string;
}

export const TESTIMONIALS: Testimonial[] = [
  {
    id: "hb-1",
    authorInitials: "HB",
    authorName: "Hervé",
    date: "01 mai 2026",
    rating: 5,
    excerpt: "Je suis très satisfait de Roole, le complément d'assurance vraiment indispensable. Je souligne le professionnalisme et l'efficacité des intervenants dans la procédure d'une prise en charge et du remboursement d'une franchise appliquée par mon assurance suite à un choc avec un animal sauvage. L'étude du dossier et le paiement de la franchise ont été très rapides.",
  },
  {
    id: "eg-1",
    authorInitials: "EG",
    authorName: "Elisabeth",
    date: "26 mai 2026",
    rating: 5,
    excerpt: "Prise en charge du dossier et remboursement très rapide. Déclaration du sinistre via l'application simple.",
  },
  {
    id: "ep-1",
    authorInitials: "EP",
    authorName: "Eric",
    date: "27 mai 2026",
    rating: 5,
    excerpt: "J'ai beaucoup apprécié la disponibilité et la réactivité des opérateurs. Lors de mon sinistre, le remorquage et la location d'un véhicule ont entièrement été gérés par Roole. Pour conclure, une fois mon dossier complet, j'ai reçu le remboursement de ma franchise dans les 48 heures.",
  },
];
